'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import programFaqs from '@/data/programFaqs';

export default function ProgramFaqs() {
  const [faqData, setFaqData] = useState(null);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const pathname = usePathname();

  useEffect(() => {
    // Extract the slug based on the path pattern
    let slug;
    const pathParts = pathname.split('/').filter(part => part);
    
    // Check if it's a workshop path
    if (pathParts[0] === 'workshops') {
      // For workshop paths, use format "workshops/[slug]"
      slug = `workshops/${pathParts[1]}`;
    } else {
      // For regular paths, just use the last part as the slug
      slug = pathParts[pathParts.length - 1];
    }
    
    // Find matching program faqs
    const matchingProgram = programFaqs.find(program => program.slug === slug);
    
    if (matchingProgram) {
      setFaqData(matchingProgram.faqs);
    } else {
      // Fallback to first program if no match found
      setFaqData(programFaqs.length > 0 ? programFaqs[0].faqs : null);
    }
  }, [pathname]);

  const toggleFaq = (faqNumber) => {
    if (expandedFaq === faqNumber) {
      setExpandedFaq(null);
    } else {
      setExpandedFaq(faqNumber);
    }
  };

  if (!faqData) {
    return null;
  }

  return (
    <div className="mt-20">
      <h2 className="text-[#002726] text-2xl md:text-[32px] font-medium mb-6">Frequently Asked Questions</h2>
      
      <div className="space-y-4">
        {faqData.map((faq) => (
          <div 
            key={faq.faqNumber}
            className="border border-[rgba(0,39,38,0.2)] rounded-2xl overflow-hidden"
          >
            <button 
              onClick={() => toggleFaq(faq.faqNumber)} 
              className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
            >
              <div>
                <h3 className="text-[#002726] text-lg md:text-base font-medium">{faq.question}</h3>
              </div>
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={`transform transition-transform flex-shrink-0 ml-2 ${expandedFaq === faq.faqNumber ? 'rotate-180' : ''}`}
              >
                <path d="M6 9L12 15L18 9" stroke="#002726" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            {expandedFaq === faq.faqNumber && (
              <div className="px-6 pb-6">
                <p className="text-[#002726] text-base font-normal">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}